
import { Component, Vue, Model } from "vue-property-decorator";
import { IdentityProvidersModel } from "@flosum-auth/contracts";
import AppCard from "@/modules/shared/components/AppCard.vue";
import AppInput from "@/modules/shared/components/AppInput.vue";
import AppFileInput from "@/modules/shared/components/AppFileInput.vue";

export type IdentityProvidersButtonInformationData = Omit<
  Pick<IdentityProvidersModel, "buttonText" | "buttonImageId">,
  "buttonImageFile"
> & {
  buttonImageFile: File | null;
};

@Component({
  components: {
    AppCard,
    AppInput,
    AppFileInput,
  },
})
export default class IdentityProvidersButtonInformation extends Vue {
  @Model("changed")
  public readonly model!: IdentityProvidersButtonInformationData | null;

  public getValue<K extends keyof IdentityProvidersButtonInformationData>(
    key: K,
    defaultValue: IdentityProvidersButtonInformationData[K]
  ): IdentityProvidersButtonInformationData[K] {
    return (this.model && this.model[key]) || defaultValue;
  }

  public update<K extends keyof IdentityProvidersButtonInformationData>(
    key: K,
    value: IdentityProvidersButtonInformationData[K]
  ): void {
    this.$emit("changed", {
      ...this.model,
      [key]: value,
    });
  }
}
